import { LngLat, LngLatBounds } from "maplibre-gl";

/**
 * Clamp a number between min and max.
 */
function clamp(value: number, min: number, max: number): number {
    return Math.min(Math.max(value, min), max);
}

/**
 * Given southwest and northeast [lng, lat] pairs,
 * clamp each component to valid ranges and return an LngLatBounds.
 */
export const getLngLatBounds = (
    sw: [number, number],
    ne: [number, number]
): LngLatBounds => {
    const [swLng, swLat] = sw;
    const [neLng, neLat] = ne;

    // Clamp longitudes to [-180, 180]
    const clampedSwLng = clamp(swLng, -180, 180);
    const clampedNeLng = clamp(neLng, -180, 180);

    // Clamp latitudes to [-90, 90]
    const clampedSwLat = clamp(swLat, -90, 90);
    const clampedNeLat = clamp(neLat, -90, 90);

    // Optionally: ensure the SW corner is truly southwest of the NE corner:
    //   const finalSwLng = Math.min(clampedSwLng, clampedNeLng);
    //   const finalNeLng = Math.max(clampedSwLng, clampedNeLng);
    //   const finalSwLat = Math.min(clampedSwLat, clampedNeLat);
    //   const finalNeLat = Math.max(clampedSwLat, clampedNeLat);

    const finalSwLng = clampedSwLng;
    const finalNeLng = clampedNeLng;
    const finalSwLat = clampedSwLat;
    const finalNeLat = clampedNeLat;

    return new LngLatBounds(
        new LngLat(finalSwLng, finalSwLat),
        new LngLat(finalNeLng, finalNeLat)
    );
};
